/**
 * Görünüm (kişisel arayüz tercihleri) — TEK KAYNAK (devam/gorunum/SOZLESME.md §2, SOZLESME-B.md §1).
 *
 * Saklama:
 *  - localStorage `mino.gorunum.<userId>` : kullanıcının tercihi (JSON, {@link GorunumTercihi})
 *  - localStorage `mino.gorunum.son`      : cihazdaki son tercih (kullanıcı henüz bilinmezken, ör. giriş ekranında)
 *  - sunucu (hesapla birlikte, her bilgisayarda): useGorunumSenkron.ts — localStorage onun önbelleğidir. Sunucu kaydı
 *    BİRLEŞTİRİR (KullaniciTercihService.benimKaydet: eski JSON'un üstüne, alt nesneler bir kat derin): eski sürümle açık
 *    kalmış bir sekmenin kaydı yeni sürümün eklediği alanları silmez.
 * Kullanıcıya özel kayıt yoksa (ilk kez) eski Pusula anahtarı `mino.menu.dar.<userId>` "1" ise menü "dar" başlar (tek
 * seferlik göç; eski anahtar bir daha yazılmaz).
 *
 * <html> öznitelikleri (çözümlenmiş; CSS YALNIZ bunlara bakar):
 *   data-menu="genis|dar|gizli|tam-ekran"  data-tema="acik|koyu"  data-hareket="az|normal"
 *   + {@link KABUK_OZNITELIKLERI} tablosundakiler: data-yogunluk, data-kenar, data-vurgu, data-koyu-ton, data-kontrast,
 *     data-odak. Bunlar tercihin HAM değeridir, temaya göre çözülmez: kenar rengi ve yüksek kontrast yalnız açık temada,
 *     koyu ton yalnız koyuda anlamlıdır — CSS seçici `html[data-tema="acik"][data-kenar="gri"]` gibi ikisine birden bakar.
 * Tablo, sekme, bildirim ve kısayol tercihleri <html>'e GİRMEZ: Redux `state.theme.gorunum` üzerinden okunur.
 *
 * İLK BOYAMA: public/index.html <head>'indeki satır içi betik bu dosyadan ÜRETİLİR (`node scripts/gorunum/ilk-boyama-uret.cjs`;
 * denetim `--denetle`). Betiğin verisi {@link ILK_BOYAMA} (anahtarlar, geçerli değerler, varsayılanlar, OZELLIKLER, yollar);
 * mantığı gorunumOku + htmlUygula'nın ES5 karşılığı. Buradaki tablo ya da bayrak değişince üreteci çalıştır; menü / tema /
 * hareket çözümlemesinin MANTIĞI değişirse üretecin şablonu da değişmeli.
 */

export type MenuDuzeni = "genis" | "dar" | "gizli" | "tamEkran";   // tamEkran: tam ekran menü (Aşama 2, açık)
export type TemaSecimi = "acik" | "koyu" | "sistem";               // koyu/sistem: Aşama 3'ten beri Görünüm'de ("Deneme")
export type TabloYogunlugu = "siki" | "ferah";                     // siki = bugünkü
export type HareketSecimi = "sistem" | "az" | "normal";
export type TabloCizgi = "tam" | "yatay";                          // tam = bugünkü
export type TabloYazisi = "normal" | "buyuk";                      // normal = bugünkü; büyük = 13px yazı, satır ≥ 28px
export type SekmeSabitYeri = "satir" | "ust";                      // satir: sekme satırının başında; ust: üstte ayrı satır
export type SekmeSiniri = "uyar" | "enEskiyiKapat";                // uyar = bugünkü (30 sekme)
export type YeniSekmeYeri = "sona" | "yanina";                     // sona = bugünkü; yanina = etkin sekmenin sağına
/** bildirimin ekrandaki yeri; "ust" = bugünkü (antd "top"). antd karşılığı {@link BILDIRIM_YERLESIMI} */
export type BildirimKonumu = "ust" | "sagUst" | "sagAlt" | "solAlt";
export type BasariSuresi = "normal" | "kisa";                      // normal = bugünkü 4,5 sn
export type KenarRengi = "lacivert" | "acik" | "gri";              // lacivert = bugünkü (yalnız açık temada)
export type VurguRengi = "mavi" | "lacivert" | "mor" | "yesil" | "turuncu" | "kirmizi";   // mavi = #038fde
export type KoyuTon = "los" | "siyah";                             // los = bugünkü koyu
export type Kontrast = "normal" | "yuksek";                        // yalnız açık temada; yüksekte ana renk #007cc2

/** bildirim tercihleri (sunucuda bir kat derin birleştirilir); varsayılanlar bugünkü davranış */
export interface BildirimTercihi {
    /** varsayılan "ust" */
    konum: BildirimKonumu;
    /** başarı bildiriminin süresi; varsayılan "normal" */
    basariSuresi: BasariSuresi;
    /** hata bildirimi kapatılana dek kalır; varsayılan false */
    hataKalici: boolean;
    /** bildirimde ses; varsayılan false */
    ses: boolean;
    /** sekme arka plandayken masaüstü bildirimi (tarayıcı izni varsa); varsayılan false */
    masaustu: boolean;
}

export interface GorunumTercihi {
    surum: 1;
    /** varsayılan "genis"; ilk okumada eski `mino.menu.dar.<id>` true ise "dar" */
    menuDuzeni: MenuDuzeni;
    /** varsayılan "acik" */
    tema: TemaSecimi;
    /** varsayılan "siki" */
    tabloYogunlugu: TabloYogunlugu;
    /** varsayılan "sistem" */
    hareket: HareketSecimi;
    /** varsayılan true (bugünkü davranış) */
    sekmeleriGeriYukle: boolean;
    /** satış / restoran kategori ve bölge şeritlerinde birden çok seçim; false: dokunulan tek başına seçilir. Varsayılan true */
    cokluKategoriSecimi: boolean;
    /** yeni oturumda açılıp etkin olacak ekranın anahtarı (menü yolu, ör. "muhasebe/genelmuhasebe/MuhasebeFisleri"); varsayılan null */
    acilisEkrani: string | null;
    /** tablo çizgileri; varsayılan "tam" */
    tabloCizgi: TabloCizgi;
    /** ardışık satırlar hafif ayrılır; varsayılan false */
    tabloZebra: boolean;
    /** üzerine gelinen sütun vurgulanır (ag-grid columnHoverHighlight); varsayılan false */
    sutunVurgusu: boolean;
    /** tablo yazı boyu; varsayılan "normal" */
    tabloYazisi: TabloYazisi;
    /** sayısal sütunlarda eksi değer kırmızı; varsayılan false */
    sayiEksiKirmizi: boolean;
    /** sayısal sütunlarda sıfır soluk; varsayılan false */
    sayiSifirSoluk: boolean;
    /** sabitlenmiş sekmelerin yeri; varsayılan "satir" */
    sekmeSabitYeri: SekmeSabitYeri;
    /** sekme sınırı dolunca; varsayılan "uyar" */
    sekmeSiniri: SekmeSiniri;
    /** yeni sekmenin yeri; varsayılan "sona" */
    yeniSekmeYeri: YeniSekmeYeri;
    /** bildirim tercihleri */
    bildirim: BildirimTercihi;
    /** belirgin klavye odağı (html[data-odak="belirgin"]); varsayılan false */
    odakBelirgin: boolean;
    /** düğmelerde kısayol etiketi (F7, Ctrl+Enter); varsayılan false */
    kisayolEtiketi: boolean;
    /** kenar çubuğu rengi (yalnız açık temada); varsayılan "lacivert" */
    kenarRengi: KenarRengi;
    /** vurgu (ana) rengi; varsayılan "mavi" (#038fde) */
    vurgu: VurguRengi;
    /** koyu temanın tonu; varsayılan "los" */
    koyuTon: KoyuTon;
    /** kontrast (açık temada); varsayılan "normal" */
    kontrast: Kontrast;
}

/** setGorunum yaması: verilen alanlar değişir; `bildirim` bir kat derin birleştirilir (yalnız verilen alt alanlar) */
export type GorunumYamasi = Partial<Omit<GorunumTercihi, "bildirim">> & { bildirim?: Partial<BildirimTercihi> };

export const VARSAYILAN_BILDIRIM: BildirimTercihi = Object.freeze({
    konum: "ust",
    basariSuresi: "normal",
    hataKalici: false,
    ses: false,
    masaustu: false,
}) as BildirimTercihi;

export const VARSAYILAN_GORUNUM: GorunumTercihi = Object.freeze({
    surum: 1,
    menuDuzeni: "genis",
    tema: "acik",
    tabloYogunlugu: "siki",
    hareket: "sistem",
    sekmeleriGeriYukle: true,
    cokluKategoriSecimi: true,
    acilisEkrani: null,
    tabloCizgi: "tam",
    tabloZebra: false,
    sutunVurgusu: false,
    tabloYazisi: "normal",
    sayiEksiKirmizi: false,
    sayiSifirSoluk: false,
    sekmeSabitYeri: "satir",
    sekmeSiniri: "uyar",
    yeniSekmeYeri: "sona",
    bildirim: VARSAYILAN_BILDIRIM,
    odakBelirgin: false,
    kisayolEtiketi: false,
    kenarRengi: "lacivert",
    vurgu: "mavi",
    koyuTon: "los",
    kontrast: "normal",
}) as GorunumTercihi;

/** bildirim konumunun antd karşılığı (notification placement) */
export const BILDIRIM_YERLESIMI: Readonly<Record<BildirimKonumu, "top" | "topRight" | "bottomRight" | "bottomLeft">> =
    Object.freeze({ust: "top", sagUst: "topRight", sagAlt: "bottomRight", solAlt: "bottomLeft"});

/** aşamalar bitince true (index.html'deki betikte de aynı bayraklar var) */
export const OZELLIKLER: { readonly TAM_EKRAN_MENU: boolean, readonly KOYU_TEMA: boolean } =
    Object.freeze({TAM_EKRAN_MENU: true, KOYU_TEMA: true});

const ONEK = "mino.gorunum.";
const SON_ANAHTAR = "mino.gorunum.son";
const ESKI_DAR_ONEK = "mino.menu.dar.";

const MENU_DUZENLERI: MenuDuzeni[] = ["genis", "dar", "gizli", "tamEkran"];
const TEMALAR: TemaSecimi[] = ["acik", "koyu", "sistem"];
const YOGUNLUKLAR: TabloYogunlugu[] = ["siki", "ferah"];
const HAREKETLER: HareketSecimi[] = ["sistem", "az", "normal"];
const TABLO_CIZGILERI: TabloCizgi[] = ["tam", "yatay"];
const TABLO_YAZILARI: TabloYazisi[] = ["normal", "buyuk"];
const SEKME_SABIT_YERLERI: SekmeSabitYeri[] = ["satir", "ust"];
const SEKME_SINIRLARI: SekmeSiniri[] = ["uyar", "enEskiyiKapat"];
const YENI_SEKME_YERLERI: YeniSekmeYeri[] = ["sona", "yanina"];
const BILDIRIM_KONUMLARI: BildirimKonumu[] = ["ust", "sagUst", "sagAlt", "solAlt"];
const BASARI_SURELERI: BasariSuresi[] = ["normal", "kisa"];
const KENAR_RENKLERI: KenarRengi[] = ["lacivert", "acik", "gri"];
const VURGU_RENKLERI: VurguRengi[] = ["mavi", "lacivert", "mor", "yesil", "turuncu", "kirmizi"];
const KOYU_TONLARI: KoyuTon[] = ["los", "siyah"];
const KONTRASTLAR: Kontrast[] = ["normal", "yuksek"];
/** açılış ekranı anahtarının üst sınırı (menü yolu) */
const ACILIS_EKRANI_EN_COK = 200;

/** Görünüm ekranının seçenek listeleri için (sıra = ekrandaki sıra) */
export const GORUNUM_SECENEKLERI = Object.freeze({
    menuDuzeni: MENU_DUZENLERI,
    tema: TEMALAR,
    tabloYogunlugu: YOGUNLUKLAR,
    hareket: HAREKETLER,
    tabloCizgi: TABLO_CIZGILERI,
    tabloYazisi: TABLO_YAZILARI,
    sekmeSabitYeri: SEKME_SABIT_YERLERI,
    sekmeSiniri: SEKME_SINIRLARI,
    yeniSekmeYeri: YENI_SEKME_YERLERI,
    bildirimKonumu: BILDIRIM_KONUMLARI,
    basariSuresi: BASARI_SURELERI,
    kenarRengi: KENAR_RENKLERI,
    vurgu: VURGU_RENKLERI,
    koyuTon: KOYU_TONLARI,
    kontrast: KONTRASTLAR,
});

/**
 * İlk boyamada <html>'e giden, tercihin değerini doğrudan yansıtan öznitelikler (alan → öznitelik; değer eşlemesi).
 * htmlUygula ve index.html'deki üretilmiş betik AYNI tabloyu kullanır. Tablo / sekme / bildirim / kısayol tercihleri
 * buraya EKLENMEZ (Redux'tan okunur; ilk boyama betiği büyümez).
 */
export const KABUK_OZNITELIKLERI: ReadonlyArray<{ alan: keyof GorunumTercihi, oznitelik: string, degerler: Readonly<Record<string, string>> }> = [
    {alan: "tabloYogunlugu", oznitelik: "data-yogunluk", degerler: {siki: "siki", ferah: "ferah"}},
    {alan: "kenarRengi", oznitelik: "data-kenar", degerler: {lacivert: "lacivert", acik: "acik", gri: "gri"}},
    {
        alan: "vurgu", oznitelik: "data-vurgu",
        degerler: {mavi: "mavi", lacivert: "lacivert", mor: "mor", yesil: "yesil", turuncu: "turuncu", kirmizi: "kirmizi"}
    },
    {alan: "koyuTon", oznitelik: "data-koyu-ton", degerler: {los: "los", siyah: "siyah"}},
    {alan: "kontrast", oznitelik: "data-kontrast", degerler: {normal: "normal", yuksek: "yuksek"}},
    {alan: "odakBelirgin", oznitelik: "data-odak", degerler: {"false": "normal", "true": "belirgin"}},
];

/** kullanıcı id'si hazır mı (0 / boş değil): hazır değilse kullanıcıya özel anahtar okunmaz, yazılmaz */
const kullaniciHazir = (id: unknown): id is number =>
    id !== undefined && id !== null && id !== 0 && id !== "";

const oku = (anahtar: string): string | null => {
    try {
        return window.localStorage.getItem(anahtar);
    } catch (e) {
        return null;
    }
};

const yaz = (anahtar: string, deger: string) => {
    try {
        window.localStorage.setItem(anahtar, deger);
    } catch (e) {
        /* kota dolu ya da özel mod: sessizce vazgeç */
    }
};

/** localStorage 'user' (girişte authSlice yazar) → userId; yoksa / bozuksa undefined */
export const gecerliKullaniciId = (): number | undefined => {
    try {
        const ham = oku("user");
        const id = ham ? JSON.parse(ham)?.userId : undefined;
        return kullaniciHazir(id) ? id : undefined;
    } catch (e) {
        return undefined;
    }
};

const secenek = <T extends string>(deger: unknown, gecerli: T[], varsayilan: T): T =>
    gecerli.includes(deger as T) ? deger as T : varsayilan;

const evetHayir = (deger: unknown, varsayilan: boolean): boolean => typeof deger === "boolean" ? deger : varsayilan;

const nesne = (ham: unknown): any => ham && typeof ham === "object" && !Array.isArray(ham) ? ham : {};

/** açılış ekranı: boş olmayan, en çok 200 karakterlik menü yolu; değilse null */
const acilisEkraniDogrula = (deger: unknown): string | null => {
    if (typeof deger !== "string") {
        return null;
    }
    const kirpik = deger.trim();
    return kirpik && kirpik.length <= ACILIS_EKRANI_EN_COK ? kirpik : null;
};

const bildirimDogrula = (ham: unknown): BildirimTercihi => {
    const b = nesne(ham);
    const v = VARSAYILAN_BILDIRIM;
    return {
        konum: secenek(b.konum, BILDIRIM_KONUMLARI, v.konum),
        basariSuresi: secenek(b.basariSuresi, BASARI_SURELERI, v.basariSuresi),
        hataKalici: evetHayir(b.hataKalici, v.hataKalici),
        ses: evetHayir(b.ses, v.ses),
        masaustu: evetHayir(b.masaustu, v.masaustu),
    };
};

/**
 * Ham değerden (nesne ya da JSON metni) geçerli tercih: bilinmeyen alan / değer atılır, eksik alan varsayılanla dolar.
 * Alan sırası sabit (JSON karşılaştırması için).
 */
export const gorunumDogrula = (ham: unknown): GorunumTercihi => {
    let kaynak: any = ham;
    if (typeof ham === "string") {
        try {
            kaynak = JSON.parse(ham);
        } catch (e) {
            kaynak = undefined;
        }
    }
    kaynak = nesne(kaynak);
    const v = VARSAYILAN_GORUNUM;
    return {
        surum: 1,
        menuDuzeni: secenek(kaynak.menuDuzeni, MENU_DUZENLERI, v.menuDuzeni),
        tema: secenek(kaynak.tema, TEMALAR, v.tema),
        tabloYogunlugu: secenek(kaynak.tabloYogunlugu, YOGUNLUKLAR, v.tabloYogunlugu),
        hareket: secenek(kaynak.hareket, HAREKETLER, v.hareket),
        sekmeleriGeriYukle: evetHayir(kaynak.sekmeleriGeriYukle, v.sekmeleriGeriYukle),
        cokluKategoriSecimi: evetHayir(kaynak.cokluKategoriSecimi, v.cokluKategoriSecimi),
        acilisEkrani: acilisEkraniDogrula(kaynak.acilisEkrani),
        tabloCizgi: secenek(kaynak.tabloCizgi, TABLO_CIZGILERI, v.tabloCizgi),
        tabloZebra: evetHayir(kaynak.tabloZebra, v.tabloZebra),
        sutunVurgusu: evetHayir(kaynak.sutunVurgusu, v.sutunVurgusu),
        tabloYazisi: secenek(kaynak.tabloYazisi, TABLO_YAZILARI, v.tabloYazisi),
        sayiEksiKirmizi: evetHayir(kaynak.sayiEksiKirmizi, v.sayiEksiKirmizi),
        sayiSifirSoluk: evetHayir(kaynak.sayiSifirSoluk, v.sayiSifirSoluk),
        sekmeSabitYeri: secenek(kaynak.sekmeSabitYeri, SEKME_SABIT_YERLERI, v.sekmeSabitYeri),
        sekmeSiniri: secenek(kaynak.sekmeSiniri, SEKME_SINIRLARI, v.sekmeSiniri),
        yeniSekmeYeri: secenek(kaynak.yeniSekmeYeri, YENI_SEKME_YERLERI, v.yeniSekmeYeri),
        bildirim: bildirimDogrula(kaynak.bildirim),
        odakBelirgin: evetHayir(kaynak.odakBelirgin, v.odakBelirgin),
        kisayolEtiketi: evetHayir(kaynak.kisayolEtiketi, v.kisayolEtiketi),
        kenarRengi: secenek(kaynak.kenarRengi, KENAR_RENKLERI, v.kenarRengi),
        vurgu: secenek(kaynak.vurgu, VURGU_RENKLERI, v.vurgu),
        koyuTon: secenek(kaynak.koyuTon, KOYU_TONLARI, v.koyuTon),
        kontrast: secenek(kaynak.kontrast, KONTRASTLAR, v.kontrast),
    };
};

/**
 * Tercih + yama → geçerli tercih. Yamadaki alanlar değişir; `bildirim` bir kat derin birleştirilir (sunucudaki
 * benimKaydet birleştirmesiyle aynı kural). Redux setGorunum bunu kullanır.
 */
export const gorunumBirlestir = (t: GorunumTercihi, yama: GorunumYamasi | undefined | null): GorunumTercihi => {
    // değeri undefined olan alan "verilmemiş" sayılır (JSON'a da girmez): `{...t, ...{bildirim: undefined}}` alanı
    // varsayılana döndürmesin
    const tanimli = (o: any): any =>
        Object.fromEntries(Object.entries(nesne(o)).filter(([, deger]) => deger !== undefined));
    const y: any = tanimli(yama);
    const birlesik: any = {...t, ...y};
    birlesik.bildirim = {...t.bildirim, ...tanimli(y.bildirim)};
    return gorunumDogrula(birlesik);
};

/** iki tercih aynı mı (alan alan) */
export const gorunumAyni = (a: GorunumTercihi, b: GorunumTercihi): boolean =>
    JSON.stringify(gorunumDogrula(a)) === JSON.stringify(gorunumDogrula(b));

/**
 * Kullanıcının saklanan tercihi: `mino.gorunum.<id>`; yoksa göç (eski `mino.menu.dar.<id>` "1" → "dar") ya da varsayılan.
 * Kullanıcı id'si yoksa yalnız cihaz kopyası `mino.gorunum.son`.
 */
export const gorunumOku = (kullaniciId?: number): GorunumTercihi => {
    if (!kullaniciHazir(kullaniciId)) {
        return gorunumDogrula(oku(SON_ANAHTAR));
    }
    const ham = oku(ONEK + kullaniciId);
    if (ham) {
        return gorunumDogrula(ham);
    }
    return oku(ESKI_DAR_ONEK + kullaniciId) === "1"
        ? gorunumDogrula({menuDuzeni: "dar"})
        : gorunumDogrula(undefined);
};

/** Tercihi tarayıcıya yazar: kullanıcıya özel anahtar (id hazırsa) + cihaz kopyası `mino.gorunum.son` */
export const gorunumYazYerel = (kullaniciId: number | undefined, t: GorunumTercihi): void => {
    const json = JSON.stringify(gorunumDogrula(t));
    if (kullaniciHazir(kullaniciId)) {
        yaz(ONEK + kullaniciId, json);
    }
    yaz(SON_ANAHTAR, json);
};

/** Tarayıcıdaki kullanıcıya özel anahtar (başka sekmedeki değişikliği izlemek için: `storage` olayı) */
export const gorunumAnahtari = (kullaniciId: number): string => ONEK + kullaniciId;

const medya = (sorgu: string): boolean => {
    try {
        return !!window.matchMedia?.(sorgu)?.matches;
    } catch (e) {
        return false;
    }
};

export const KOYU_SORGUSU = "(prefers-color-scheme: dark)";
export const HAREKET_AZ_SORGUSU = "(prefers-reduced-motion: reduce)";

/** etkin menü düzeni: açılmamış aşamanın düzeni (tamEkran) bugünkü düzene düşer */
export const etkinMenuDuzeni = (t: GorunumTercihi): MenuDuzeni =>
    t.menuDuzeni === "tamEkran" && !OZELLIKLER.TAM_EKRAN_MENU ? "genis" : t.menuDuzeni;

/** etkin tema: koyu tema açılmadıysa HER ZAMAN "acik"; "sistem" işletim sisteminin ayarından */
export const etkinTema = (t: GorunumTercihi): "acik" | "koyu" => {
    if (!OZELLIKLER.KOYU_TEMA) {
        return "acik";
    }
    if (t.tema === "sistem") {
        return medya(KOYU_SORGUSU) ? "koyu" : "acik";
    }
    return t.tema === "koyu" ? "koyu" : "acik";
};

/** etkin hareket: "sistem" işletim sisteminin "hareketi azalt" ayarından */
export const etkinHareket = (t: GorunumTercihi): "az" | "normal" => {
    if (t.hareket === "sistem") {
        return medya(HAREKET_AZ_SORGUSU) ? "az" : "normal";
    }
    return t.hareket === "az" ? "az" : "normal";
};

/** girişsiz sayfalar (App.tsx Routes; token gerekmez) ve giriş ekranı: tema HER ZAMAN açık (Aşama 3) */
const GIRISSIZ_YOL = /^\/(ihale-teklif|qr-menu|mutabakat)(\/|$)/;
const GIRIS_YOLU = /^\/([^/]+\/)?login\/?$/;

/**
 * Koyu tema bu sayfada uygulanabilir mi: oturum açık (localStorage `token`) ve giriş / girişsiz sayfa değil. Aksi halde
 * aynı tarayıcıdaki cihaz kopyası (`mino.gorunum.son`) giriş ekranını ve tedarikçi / QR menü / mutabakat sayfalarını koyu
 * açardı. index.html'deki betik aynı kuralı uygular.
 */
export const koyuIzinli = (yol?: string): boolean => {
    try {
        const p = yol ?? window.location.pathname ?? "/";
        if (GIRISSIZ_YOL.test(p) || GIRIS_YOLU.test(p)) {
            return false;
        }
        return !!oku("token");
    } catch (e) {
        return false;
    }
};

/**
 * Koyu tema stil dosyası: webpack'ten geçmeyen stillerin (public/css/style.css, mino_style, loader.css, çalışma anında
 * eklenen simge CSS'i) koyu karşılığı — `npm run koyu-css` üretir. Paketteki CSS'in koyusu eklentiyle pakette
 * (scripts/koyu/postcss-koyu.cjs). index.html ilk boyamada aynı id ile ekler.
 */
export const KOYU_CSS_ID = "koyu-css";
const koyuCssAdresi = () => `${process.env.PUBLIC_URL ?? ""}/css/koyu.css`;
/**
 * <meta name="theme-color">: koyuda kart yüzeyi (scripts/koyu --kd-yuzey; "siyah" tonda koyu.css'teki
 * html[data-tema="koyu"][data-koyu-ton="siyah"] --ks-z202328 karşılığı), açıkta index.html'deki değer
 */
const TEMA_RENGI = {acik: "#000000", koyu: "#202328", koyuSiyah: "#0e1115"};
const koyuTemaRengi = (ton: KoyuTon): string => ton === "siyah" ? TEMA_RENGI.koyuSiyah : TEMA_RENGI.koyu;

/** son tema geçişi: koyu.css geç yüklenirken tema yeniden değiştiyse eski geçişin yükleme olayı bir şey yapmaz */
let gecisNo = 0;

/**
 * data-tema + koyu.css <link> + theme-color. Koyuya geçerken koyu.css henüz yüklenmediyse önce yüklenir, data-tema
 * yükleme bitince (ya da hata / 3 sn sonra) "koyu" olur: style.css'in koyusu gelmeden yarım koyu ekran görünmesin.
 * Açığa dönünce <link> kaldırılır.
 */
const temaUygula = (kok: HTMLElement, tema: "acik" | "koyu", ton: KoyuTon) => {
    const no = ++gecisNo;
    const meta = document.querySelector('meta[name="theme-color"]');
    let link = document.getElementById(KOYU_CSS_ID) as HTMLLinkElement | null;
    if (tema === "acik") {
        kok.setAttribute("data-tema", "acik");
        link?.remove();
        meta?.setAttribute("content", TEMA_RENGI.acik);
        return;
    }
    const koyuYap = () => {
        if (no === gecisNo) {
            kok.setAttribute("data-tema", "koyu");
            meta?.setAttribute("content", koyuTemaRengi(ton));
        }
    };
    if (link?.sheet) {
        // yüklü (index.html ya da önceki geçiş)
        koyuYap();
        return;
    }
    if (!link) {
        link = document.createElement("link");
        link.rel = "stylesheet";
        link.id = KOYU_CSS_ID;
        link.href = koyuCssAdresi();
        // index.html'deki yer: ilk stil dosyasının (loader.css / style.css) ÖNÜ. Sona eklenseydi style.css'in koyusu
        // paketin (modül scss) koyusundan SONRA gelir, aynı özgüllükte açık temadaki sıranın tersi kazanırdı
        document.head.insertBefore(link, document.head.querySelector('link[rel="stylesheet"]'));
    }
    link.addEventListener("load", koyuYap, {once: true});
    link.addEventListener("error", koyuYap, {once: true});
    setTimeout(koyuYap, 3000);
};

/** tablo satırının değeri: tercihin değeri tabloda yoksa varsayılanınki */
const kabukDegeri = (t: GorunumTercihi, satir: typeof KABUK_OZNITELIKLERI[number]): string => {
    const d = String(t[satir.alan]);
    return Object.prototype.hasOwnProperty.call(satir.degerler, d)
        ? satir.degerler[d]
        : satir.degerler[String(VARSAYILAN_GORUNUM[satir.alan])];
};

/** <html> öznitelikleri (çözümlenmiş değerler) */
export const htmlUygula = (t: GorunumTercihi): void => {
    try {
        const kok = document.documentElement;
        const menu = etkinMenuDuzeni(t);
        kok.setAttribute("data-menu", menu === "tamEkran" ? "tam-ekran" : menu);
        temaUygula(kok, koyuIzinli() ? etkinTema(t) : "acik", t.koyuTon);
        KABUK_OZNITELIKLERI.forEach(satir => kok.setAttribute(satir.oznitelik, kabukDegeri(t, satir)));
        kok.setAttribute("data-hareket", etkinHareket(t));
    } catch (e) {
        /* belge yok (test ortamı) */
    }
};

/**
 * İlk boyama betiğinin verisi (public/index.html; `node scripts/gorunum/ilk-boyama-uret.cjs` bu nesneyi okuyup betiği
 * yazar). Yalnız düz veri: anahtarlar, geçerli değerler, varsayılanlar, bayraklar, yollar, kabuk öznitelikleri.
 */
export const ILK_BOYAMA = Object.freeze({
    anahtar: {onek: ONEK, son: SON_ANAHTAR, eskiDar: ESKI_DAR_ONEK},
    ozellikler: OZELLIKLER,
    menuDuzenleri: MENU_DUZENLERI,
    varsayilanMenu: VARSAYILAN_GORUNUM.menuDuzeni,
    temalar: TEMALAR,
    varsayilanTema: VARSAYILAN_GORUNUM.tema,
    hareketler: HAREKETLER,
    varsayilanHareket: VARSAYILAN_GORUNUM.hareket,
    girissizYol: GIRISSIZ_YOL.source,
    girisYolu: GIRIS_YOLU.source,
    koyuSorgusu: KOYU_SORGUSU,
    hareketAzSorgusu: HAREKET_AZ_SORGUSU,
    koyuCssId: KOYU_CSS_ID,
    koyuTemaRengi: TEMA_RENGI.koyu,
    /** koyuTon "siyah" iken theme-color */
    koyuSiyahRengi: TEMA_RENGI.koyuSiyah,
    kabuk: KABUK_OZNITELIKLERI.map(satir => ({
        oznitelik: satir.oznitelik,
        alan: satir.alan,
        degerler: satir.degerler,
        /** ham JSON'daki değerin beklenen türü ("string" | "boolean"): başka türdeki değer varsayılana düşer (gorunumDogrula gibi) */
        tur: typeof VARSAYILAN_GORUNUM[satir.alan],
        varsayilan: String(VARSAYILAN_GORUNUM[satir.alan]),
    })),
});
